import React, {Component} from 'react';
import CustomPaper from "../../shared/utils/CustomPaper";
import {List, ListItem} from 'material-ui/List';
import IconButton from 'material-ui/IconButton';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';
import {IconMenu} from 'material-ui/IconMenu';
import MenuItem from 'material-ui/MenuItem';
import Divider from 'material-ui/Divider';
import ActionDescription from 'material-ui/svg-icons/action/description';
import {blue200} from 'material-ui/styles/colors';
import {OffreDetails} from '../../shared/utils/OfferDetails';
import {connect} from "react-redux"
import SalarieService from "../services/SalarieService";
import EntrepriseService from "../../entreprise/bodies/services/EntrepriseService";
import moment from "../../shared/utils/moment_fr";
import Alert from '../../shared/utils/Alert';


class PostesDisponiblesSalarie extends Component {

    static LEFT_PANEL_VIEW = {
        NONE: 0,
        OFFER_DETAILS: 2,
    };

    constructor(props) {
        super(props);
        this.state = {
            rightPanelView: PostesDisponiblesSalarie.LEFT_PANEL_VIEW.NONE,
            selectedOffer: null,
            postes: [],
            candidatures: []
        };

        this.salarieService = new SalarieService();
        this.entrepriseService = new EntrepriseService();
        this.getAllPostes = this.getAllPostes.bind(this);
        this.getAllCandidatures = this.getAllCandidatures.bind(this);
        this.showOffer = this.showOffer.bind(this);
        this.onCandidaterClick = this.onCandidaterClick.bind(this);
        this.onDeleteCandidatureClick = this.onDeleteCandidatureClick.bind(this);
    }

    static parseEtat(e) {
        switch (e) {
            case '0':
                return <span className="badge badge-primary">Envoyée</span>;
            case '1':
                return <span className="badge badge-success">Acceptée</span>;
            case '2':
                return <span className="badge badge-warning">Refusée</span>;
            default:
                return <span className="badge badge-primary">Envoyée</span>;
        }
    }

    onCandidaterClick(id_offre) {
        const x = window.confirm('Êtes vous sûr de vouloir candidater pour ce poste ?');
        if (x) {
            this.salarieService.candidaterPosteInterne(id_offre)
                .then(() => {
                    this.getAllCandidatures();
                    window.alert('Candidature envoyée');
                })
        }

    }

    onDeleteCandidatureClick(id_candidature) {
        const x = window.confirm('Êtes vous sûr de vouloir annuler votre candidature ?');
        if (x) {
            this.salarieService.annulerCandidaturePoste(id_candidature)
                .then(() => {
                    this.getAllCandidatures();
                    window.alert('Candidature supprimée');
                })
        }
    }

    componentDidMount() {
        this.getAllPostes();
        this.getAllCandidatures();
    }

    getAllCandidatures() {
        this.salarieService.getCandidatureBySalarie()
            .then((x) => this.setState({candidatures: x.data.payload}))
    }

    getAllPostes() {
        this.entrepriseService.getEntreprisePostes()
            .then(x => this.setState({postes: x.data.payload}));
    }

    showOffer(o) {
        this.setState({
            rightPanelView: PostesDisponiblesSalarie.LEFT_PANEL_VIEW.OFFER_DETAILS,
            selectedOffer: o
        });
    }

    render() {
        const offer = this.state.selectedOffer;

        return (
            <div>
                <div className="row col">
                    <CustomPaper title="Vos candidatures">
                        {
                            this.state.candidatures.length > 0 ? this.state.candidatures.map(c =>
                                <div key={c.id_candidature}>
                                    <label>Poste
                                        : {c.intitule} ({c.localisation + ' / ' + c.type_contrat})
                                    </label>
                                    <a
                                        style={{marginLeft: 30, color: '#FF0000'}}
                                        href="#//"
                                        onClick={() => this.onDeleteCandidatureClick(c.id_candidature)}
                                    > Supprimer</a>
                                    <br/>
                                    <label>Date de candidature : {moment(c.date_candidature).format('lll')}</label><br/>
                                    <label>Etat de la candidature
                                        : {PostesDisponiblesSalarie.parseEtat(c.status)}</label><br/>
                                    <br/>
                                    <Divider/>
                                </div>
                            ) : <Alert text="Vous n'avez aucune candidature enregistrée."/>
                        }
                    </CustomPaper>
                </div>
                <div className="row">
                    <div className='col-4'>
                        <CustomPaper title={"Postes disponibles en interne"}>
                            <List>
                                {
                                    this.state.postes.length > 0 ?
                                        this.state.postes.map(o =>
                                            <ListItem
                                                key={o.id}
                                                primaryText={o.intitule}
                                                secondaryText={o.localisation + ' - ' + o.type_contrat}
                                                rightIconButton={
                                                    <IconMenu iconButtonElement={
                                                        <IconButton
                                                            touch={true}
                                                            tooltip="Plus"
                                                            tooltipPosition="bottom-left"
                                                        >
                                                            <MoreVertIcon color={blue200}/>
                                                        </IconButton>
                                                    }
                                                    >
                                                        <MenuItem
                                                            onClick={() => this.onCandidaterClick(o.id)}>Candidater</MenuItem>
                                                    </IconMenu>
                                                }
                                                leftIcon={<ActionDescription color={blue200}/>}
                                                onClick={() => this.showOffer(o)}
                                            />
                                        ) : <Alert text="Aucune offre n'est publiée par votre employeur."/>
                                }
                            </List>

                        </CustomPaper>
                    </div>
                    <div className='col-8'>
                        {
                            this.state.selectedOffer && this.state.rightPanelView === PostesDisponiblesSalarie.LEFT_PANEL_VIEW.OFFER_DETAILS &&
                            <OffreDetails
                                intitule={offer.intitule}
                                descriptif={offer.descriptif}
                                type_contrat={offer.type_contrat}
                                date_publication={offer.date_publication}
                                localisation={offer.localisation}
                            />
                        }
                    </div>

                </div>
            </div>
        );
    }

}

function mapStateToProps(store) {
    return {entrepriseName: store.entreprise.entreprise_infos.nom}
}

export default connect(mapStateToProps)(PostesDisponiblesSalarie);


// WEBPACK FOOTER //
// ./src/components/salarie/bodies/PostesDisponibles.js